// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"84":"4126eca0","568":"34e83bd6","719":"423611ae","745":"be613395","985":"a602f912"}[chunkId] + ".js";
};